import { render, staticRenderFns } from "./im-list-message.vue?vue&type=template&id=c1bed422&scoped=true"
import script from "./im-list-message.vue?vue&type=script&lang=js"
export * from "./im-list-message.vue?vue&type=script&lang=js"
import style0 from "./im-list-message.vue?vue&type=style&index=0&id=c1bed422&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1bed422",
  null
  
)

export default component.exports